const bowsette = {
    title: 'Bowsette',
    description: 'Expanding on the "Bowsette" meme, except now everyone is a Peach',
    typeOfWork: 'Personal Project',
    galleryImgUrl: 'https://vsco.co/kkara9009/media/6681183a8bf0ae3ba58c59aa',
    image: '/assets/images/projects/designProjects/bowsette.jpg',
    webpImage: '/assets/images/projects/designProjects/bowsette.webp',
    key: 0
}

const psike = {
    title: 'Psiké',
    description: 'Business card and logo design for child psychologist "Sue-Tayna"',
    typeOfWork: 'Business Card',
    galleryUrl: 'https://vsco.co/kkara9009/media/66811f5528e8cb9a08fdf2b4',
    image: '/assets/images/projects/designProjects/psike.jpg',
    webpImage: '//assets/images/projects/designProjects/psike.webp',
    key: 1
}

const caneCorso = {
    title: 'Cane Corso',
    description: 'Video project for integrating video and illustrations together',
    typeOfWork: 'Personal Project',
    galleryUrl: 'https://vsco.co/kkara9009/media/66811da3522027eac0fc8efa',
    image: '/assets/images/projects/designProjects/caneCorso.jpg',
    webpImage: '/assets/images/projects/designProjects/caneCorso.webp',
    key: 2
}

const chamili = {
    title: 'Chamili',
    description: "Mascot design for client's clothing line",
    typeOfWork: 'Mascot',
    galleryUrl: 'https://vsco.co/kkara9009/media/66811cfd37496c8c76067516',
    image: '/assets/images/projects/designProjects/chamili.jpg',
    webpImage: '/assets/images/projects/designProjects/chamili.webp',
    key: 3
}

const cowlick = {
    title: 'Cowlick',
    description: "Illustrations for client's story about a boy with peculiar hair",
    typeOfWork: 'Book Illustration',
    galleryUrl: 'https://vsco.co/kkara9009/media/66811c90540560903edab760',
    image: '/assets/images/projects/designProjects/cowlick.jpg',
    webpImage: '/assets/images/projects/designProjects/cowlick.webp',
    key: 4
}

const doge = {
    title: 'Where i belong',
    description: "Illustrations for client's story about a dog searching for where he belongs",
    typeOfWork: 'Book Illustration',
    galleryUrl: 'https://vsco.co/kkara9009/media/66811c2870b339a0efb4ef0e',
    image: '/assets/images/projects/designProjects/doge.jpg',
    webpImage: '/assets/images/projects/designProjects/doge.webp',
    key: 5
}

const emojis = {
    title: 'Emojis',
    description: "Project creating alternative emoji designs",
    typeOfWork: 'Personal Project',
    galleryImgUrl: 'https://vsco.co/kkara9009/media/668118f2eaccf9a6dd606592',
    image: '/assets/images/projects/designProjects/emojis.jpg',
    webpImage: '/assets/images/projects/designProjects/emojis.webp',
    key: 6
}

const gekeerah = {
    title: 'Gekeerah',
    description: "Illustrations for client's inclusive rewriting of Cinderella",
    typeOfWork: 'Book Illustration',
    galleryUrl: 'https://vsco.co/kkara9009/media/66811bc9ec6f15de28714013',
    image: '/assets/images/projects/designProjects/gekeerah.jpg',
    webpImage: '/assets/images/projects/designProjects/gekeerah.webp',
    key: 7
}

const gitemtaylor = {
    title: 'Gitem Taylor',
    description: "Album art design for artist 'GitemTaylor'",
    typeOfWork: 'Album Art',
    galleryImgUrl: 'https://vsco.co/kkara9009/media/66811eefc00718048395a7e8',
    image: '/assets/images/projects/designProjects/gitemtaylor.jpg',
    webpImage: '/assets/images/projects/designProjects/gitemtaylor.webp',
    key: 8
}

const iTwar = {
    title: 'I-Twar',
    description: "Album art designs for UK artist 'i-twar'",
    typeOfWork: 'Album Art',
    galleryUrl: 'https://vsco.co/kkara9009/media/66811e9364b162e740eda207',
    image: '/assets/images/projects/designProjects/iTwar.jpg',
    webpImage: '/assets/images/projects/designProjects/iTwar.webp',
    key: 9
}

const marchHare = {
    title: 'March Hare',
    description: "Mascot design of 'The March Hare' for client",
    typeOfWork: 'Mascot',
    galleryImgUrl: 'https://vsco.co/kkara9009/media/66811e3716bc699f5c869e4e',
    image: '/assets/images/projects/designProjects/marchHare.jpg',
    webpImage: '/assets/images/projects/designProjects/marchHare.webp',
    key: 10
}

const miranda = {
    title: 'Miranda',
    description: "Illustrations for client's story about a marshmallow trying to escape her fate of being eaten",
    typeOfWork: 'Book Illustration',
    galleryUrl: 'https://vsco.co/kkara9009/media/66811df73b5c89761f12f746',
    image: '/assets/images/projects/designProjects/miranda.jpg',
    webpImage: '/assets/images/projects/designProjects/miranda.webp',
    key: 11
}

const stanLee = {
    title: 'Stan Lee',
    description: "Tribute illustration for the late Stan Lee",
    typeOfWork: 'Personal Project',
    galleryImgUrl: 'https://vsco.co/kkara9009/media/66811b747136c4a833b7488a',
    image: '/assets/images/projects/designProjects/stanLee.jpg',
    webpImage: '/assets/images/projects/designProjects/stanLee.webp',
    key: 12
}

const stephenHawking = {
    title: 'Stephen Hawking',
    description: "Tribute illustration for the late Stephen Hawking",
    typeOfWork: 'Personal Project',
    galleryImgUrl: 'https://vsco.co/kkara9009/media/66811b2d540560903edab75f',
    image: '/assets/images/projects/designProjects/stephenHawking.jpg',
    webpImage: '/assets/images/projects/designProjects/stephenHawking.webp',
    key: 13
}

const unsuprvsd = {
    title: "Unsuprvsd",
    description: "Instagram Promo illustration for Unsuprvsd (personal clothing brand)",
    typeOfWork: 'Personal Project',
    galleryUrl: 'https://vsco.co/kkara9009/media/6681155b1db241c242a350be',
    image: '/assets/images/projects/designProjects/unsuprvsd.jpg',
    webpImage: '/assets/images/projects/designProjects/unsuprvsd.webp',
    key: 14
}

const shiva = {
    title: "Shiva",
    description: "Exploring different culture and subculture beauty standards 3 girls at a time",
    typeOfWork: 'Personal Project',
    galleryUrl: 'https://vsco.co/kkara9009/media/668119b4b608caea1c68c084',
    image: '/assets/images/projects/designProjects/shiva.jpg',
    webpImage: '/assets/images/projects/designProjects/shiva.webp',
    key: 15
}

const turtleWarriors = {
    title: "Turtle Warriors",
    description: "Board Game assets illustrations for client",
    typeOfWork: 'Game',
    galleryUrl: 'https://vsco.co/kkara9009/media/66811ad882862a3bedaaba45',
    image: '/assets/images/projects/designProjects/turtleWarriors.jpg',
    webpImage: '/assets/images/projects/designProjects/turtleWarriors.webp',
    key: 16
}

const urbanAmir = {
    title: "Urban Amir",
    description: "Designs for client's clothing line dedicated to raising autism awareness",
    typeOfWork: 'Clothing',
    galleryUrl: 'https://vsco.co/kkara9009/media/66811fe686fd0bd9bbf5d08f',
    image: '/assets/images/projects/designProjects/urbanAmir.jpg',
    webpImage: '/assets/images/projects/designProjects/urbanAmir.webp',
    key: 17
}

const yakuza = {
    title: "Yakuza",
    description: "Video project animating with Krita",
    typeOfWork: 'Personal Project',
    galleryUrl: 'https://vsco.co/kkara9009/media/66811a494d9281690e7422bd',
    image: '/assets/images/projects/designProjects/yakuza.jpg',
    webpImage: '/assets/images/projects/designProjects/yakuza.webp',
    key: 18
}

// reverse array to ensure last projects added to array appear on top
export const featured_projects = [urbanAmir, psike, gitemtaylor, iTwar, marchHare, miranda, caneCorso, chamili, cowlick, doge, gekeerah, stanLee, stephenHawking, turtleWarriors, yakuza, shiva, emojis, unsuprvsd, bowsette].reverse()